module.exports = __webpack_public_path__ + "static/img/cadillac_5.d871c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/cadillac_5.png
// module id = qE07
// module chunks = 215